import { render, staticRenderFns } from "./modern-home-change-device.vue?vue&type=template&id=6bebb9b0&scoped=true&"
import script from "./modern-home-change-device.vue?vue&type=script&lang=js&"
export * from "./modern-home-change-device.vue?vue&type=script&lang=js&"
import style0 from "./modern-home-change-device.vue?vue&type=style&index=0&id=6bebb9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebb9b0",
  null
  
)

export default component.exports